import {
  Animation,
  Button,
  ComponentContainer,
  CustomSpacing,
  Flex,
  Icon,
  Input,
  Section,
  theme,
} from '@genially/public-web-components';
import { FC, useEffect, useState } from 'react';

import type { BackgroundDTO } from 'core/infrastructure/parseBackground';
import { parseBackground } from 'core/infrastructure/parseBackground';
import { translate } from 'core/infrastructure/translator';

interface ParagraphSearchInputProps {
  behaviorSettings?: {
    rowStyle: {
      background: BackgroundDTO;
      spacing: CustomSpacing;
      general: any;
      borders: any;
      hovers?: any;
    };
    layout_paragraphs: { layout: string; config: any };
  };
  animation?: keyof typeof theme.animations;
  targetUrl?: string;
  pagelangcode: {
    value: string;
  };
  buttonStyle?: {
    size: string;
    variant: 'academy' | 'danger' | 'primary' | 'secondary' | 'stroke' | 'tertiary' | 'strokeWhite';
  };
}

export const ParagraphSearchInput: FC<ParagraphSearchInputProps> = ({
  behaviorSettings,
  animation = 'fadeInUp',
  targetUrl,
  pagelangcode,
  buttonStyle,
}) => {
  const [inputValue, setInputValue] = useState<string>('');
  const [localSearch, setLocalSearch] = useState<string>('');
  const translateFromContent = (key: string) =>
    translate(pagelangcode ? pagelangcode.value : 'en', key);
  const placeholder = translateFromContent('template.searchplaceholder');

  function handleButtonClick() {
    setLocalSearch(inputValue);
  }

  function handleKeyPress(event: React.KeyboardEvent<HTMLInputElement>) {
    if (!inputValue) return;
    if (event.key === 'Enter') {
      handleButtonClick();
    }
  }

  useEffect(() => {
    if (!localSearch) return;
    const finalUrl =
      pagelangcode.value === 'en'
        ? `${targetUrl}/?search=${localSearch}`
        : `/${pagelangcode.value}${targetUrl}/?search=${localSearch}`;
    window.location.href = finalUrl;
  }, [localSearch]);

  return (
    <Section background={parseBackground(behaviorSettings?.rowStyle?.background)}>
      <Animation type={animation}>
        <ComponentContainer customSpacing={behaviorSettings?.rowStyle?.spacing}>
          <Flex
            flexDirection={'row'}
            alignItems="center"
            justifyContent="center"
            css={`
              max-width: 40%;
              margin: auto;
            `}
          >
            <Input
              size={'medium'}
              variant={'base'}
              placeholder={placeholder}
              value={inputValue}
              onChange={e => setInputValue((e.target as HTMLInputElement).value)}
              onKeyDown={handleKeyPress}
            />
            <div style={{ paddingLeft: '16px' }}>
              <Button
                style={{ margin: '16px 0', display: 'flex' }}
                variant={buttonStyle && buttonStyle?.variant ? buttonStyle?.variant : 'primary'}
                onClick={handleButtonClick}
              >
                <Icon name={'Search'}></Icon>
              </Button>
            </div>
          </Flex>
        </ComponentContainer>
      </Animation>
    </Section>
  );
};
